import { useAtomValue } from "jotai";
import { userAtom } from "../utils/store";
import { Navigate, useLocation } from "react-router-dom";
import { useInactivity } from "./useInactivity";

interface ComponentProp {
  children: JSX.Element;
}

const ProtectedRoute = ({ children }: ComponentProp) => {
  const user = useAtomValue(userAtom);
  let location = useLocation();
  useInactivity(!!user && !!user?.token); // Enable inactivity tracking only if user is logged in

  if (!user || !user?.token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
